import { BrowserClient, defaultStackParser, getCurrentScope, makeFetchTransport } from '@sentry/browser';

const sentryConfig = useRuntimeConfig().public.sentry;

if (sentryConfig.enabled) {
  const client = new BrowserClient({
    ...resolveSentryConfigShared(sentryConfig),

    transport: makeFetchTransport,
    stackParser: defaultStackParser,

    // Create sentry client without integrations, so they can be lazy loaded and split into their own bundle
    integrations: [],
  });

  /**
   * Lazy load integrations, prevents from bundling all this inside our main bundle.
   *
   * Order of integrations follows the tables on the link below.
   * @see https://docs.sentry.io/platforms/javascript/guides/nuxt/configuration/integrations/
   */
  import('@sentry/browser').then((lazyLoadedSentry) => {
    // Common
    client.addIntegration(lazyLoadedSentry.dedupeIntegration());
    client.addIntegration(lazyLoadedSentry.functionToStringIntegration());
    client.addIntegration(lazyLoadedSentry.inboundFiltersIntegration());
    client.addIntegration(lazyLoadedSentry.linkedErrorsIntegration());
    client.addIntegration(
      lazyLoadedSentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    );
    client.addIntegration(lazyLoadedSentry.extraErrorDataIntegration());
    client.addIntegration(lazyLoadedSentry.sessionTimingIntegration());

    // Browser only
    // Note: BreadcrumbsIntegration adds console logs to errors/traces independently of CaptureConsoleIntegration
    client.addIntegration(lazyLoadedSentry.breadcrumbsIntegration());
    client.addIntegration(lazyLoadedSentry.browserApiErrorsIntegration());
    client.addIntegration(lazyLoadedSentry.browserTracingIntegration());
    client.addIntegration(lazyLoadedSentry.globalHandlersIntegration());
    client.addIntegration(lazyLoadedSentry.browserProfilingIntegration());
    client.addIntegration(lazyLoadedSentry.contextLinesIntegration());
    client.addIntegration(lazyLoadedSentry.httpContextIntegration());
    client.addIntegration(lazyLoadedSentry.moduleMetadataIntegration());
    client.addIntegration(lazyLoadedSentry.replayIntegration());
  });

  getCurrentScope().setClient(client);
  client.init();
}
